import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  afterNextRender,
  effect,
  inject,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ThemeToggleComponent } from '@components/partials/theme-toggle/theme-toggle.component';

@Component({
  selector: 'app-public',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ThemeToggleComponent],
  templateUrl: './public.layout.html',
  styleUrl: './public.layout.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:scroll)': 'onWindowScroll()',
    '(document:keydown.escape)': 'closeMenu()',
  },
})
export class PublicLayout {
  private readonly document = inject(DOCUMENT);

  /** Drives the header's elevated state once the page has moved off the top. */
  readonly scrolled = signal(false);
  readonly menuOpen = signal(false);

  constructor() {
    // A reload part-way down the page should still paint the bar as scrolled.
    afterNextRender(() => this.onWindowScroll());

    effect(() => {
      // The sheet covers the viewport, so the page behind it should not scroll.
      this.document.body.style.overflow = this.menuOpen() ? 'hidden' : '';
    });
  }

  onWindowScroll(): void {
    this.scrolled.set(window.scrollY > 4);
  }

  toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }
}
